<template>
  <div>
    <v-switch
      :label="$t('incidentReports.workResumed')"
      data-cy="backToWork"
      v-model="value.backToWork"
    ></v-switch>
  </div>
</template>
<script>
export default {
  props: ["value"],
  data: () => ({}),
  methods: {},
};
</script>
